const THEME_VALUES = new Set(['dark', 'light', 'high-contrast', 'comfort', 'system']);

export const normalizeThemePreference = value => {
  const raw = String(value ?? '').trim().toLowerCase();
  if (THEME_VALUES.has(raw)) return raw;
  if (value === true || raw === 'true') return 'dark';
  if (value === false || raw === 'false') return 'light';
  return '';
};

export const themeFromConfig = config => (
  normalizeThemePreference(config?.theme)
  || normalizeThemePreference(config?.branding?.theme)
  || normalizeThemePreference(config?.branding?.darkMode)
  || 'system'
);

export const storedThemeKey = session => `riskTool_theme_${session?.user?.id || 'anonymous'}`;

export const systemThemePreference = () => {
  if (typeof window === 'undefined' || !window.matchMedia) return 'dark';
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
};
